import type { ReactNode } from "react";

export function PageHeader({
  title,
  hint,
  actions,
}: {
  title: string;
  hint?: string;
  actions?: ReactNode;
}) {
  return (
    <div className="page-head">
      <div>
        <h1 className="page-title">{title}</h1>
        {hint && <p className="page-hint">{hint}</p>}
      </div>
      {actions && <div className="page-actions">{actions}</div>}
    </div>
  );
}
